
import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import DataAccessHelper from "../Helper/DataAccessHelper.js";
import { registrationType } from "../Constants/RegistrationType.js";
import { CombinationPageOptions } from "../Constants/RegistrationPageOptions.js";
import { useState, useEffect } from "react";
import '../Styles/EventCard.scss';

function EventCard({ eventRegistrationType, campEvent, setWeekSelection, nextPage, setSelectedPage}) {
   const [vacancyStatus, setVacancyStatus] = useState('')
   const [duplicateEventError, setDuplicateEventError] = useState(false)
   const [duplicateDateError, setDuplicateDateError] = useState(false)
   console.log("next page", nextPage)

   async function handleVacancyStatus() {
      if (eventRegistrationType == registrationType.Combination) {
         let vacancyStatus = await DataAccessHelper.determineVacancyStatus(campEvent)
         console.log("vacancy status",vacancyStatus)
        // setVacancyStatus(vacancyStatus)
      }
   }

   async function campWeekSelection() {
      try {
         // Get Logged-in User
         // const response2 = await fetch('/api/get-user', {
         //    method: 'GET',
         //    headers: { "Content-Type": "application/json" }
         // })

         // if (response2.status === 400 || response2.status === 500) {
         //    throw new Error("Failed User Retrieval");
         // }

         // let account = await response2.json();
         // let accountId = account.user.id
         // console.log("AccountID", accountId)
         let eventId = campEvent.event_id
         let begin_date = campEvent.begin_date
         let end_date = campEvent.end_date
         console.log("EventID", eventId)
         // console.log("Registration Type", eventReservationType)
         console.log("Next page", nextPage)

         // We are not handling duplicate events for day camp, handle this later

         // Check if a registraton already exists for those dates
         // const existing = await fetch('/searchexistingregistration', {
         //    method: 'POST',
         //    headers: { "Content-Type": "application/json" },
         //    body: JSON.stringify({
         //       accountId,
         //       eventId,
         //       begin_date,
         //       end_date,
         //       eventRegistrationType
         //    })
         // })
         // console.log("Existing!!!", existing)
         // const existingResponse = await existing.json()
         // console.log("Existing Response", existingResponse)
         // var existingData = existingResponse.data.existingRegistrationQuery;

         // Display error message if registration already exists
         // if (existingData[0] != null && eventRegistrationType == registrationType.Combination) {
         //    setDuplicateDateError(true)
         // }
         // else if(existingData[0] != null && eventRegistrationType == registrationType.CombinationGroup){
         //    setDuplicateEventError(true)
         // }
         // else if(existingData[0] != null && eventRegistrationType == registrationType.Day){
         //    setDuplicateDateError(true)
         // }
         // else{
         console.log("Are We here?")
         // setDuplicateEventError(false)
         setWeekSelection(campEvent)
         setSelectedPage(nextPage)
         // }
  
      }
      catch (error) {
         console.log(error)
      }
   }

   useEffect(() => {
      handleVacancyStatus()
      setDuplicateEventError(false)
   }, [campEvent]);

   return (
         <div className='EventCardContent'>
            <div className="EventInformation">
               <div className="EventCardTitle">
                  {campEvent.camp_name}
               </div>
               <div className="EventCardDates">
                  {DateHelpers.getEventDateRange(campEvent.begin_date, campEvent.end_date)}
               </div>
               <div className="EventCardSpeaker">
                  Speaker: {campEvent.guest_speaker_name}
               </div>
               <div vacancyStatus={vacancyStatus} className="EventCardVacancyStatus">
                  {vacancyStatus}
               </div>
            </div>
            <div className="EventRegisterButton">
               <div className="EventCardEventSelectionButtonContainer">
                 {[23, 26].includes(campEvent.event_id) && eventRegistrationType === 'Combination Group'? (
                  <div className="EventCardEventClosedCaption">
                     Week Closed
                  </div>
               ) : (
                  <div className="EventCardEventSelectionButton">
                     <button onClick={() => campWeekSelection()}>
                        Select
                     </button>
                  </div>
               )}
               </div>
           
               {/* { duplicateEventError === true &&
                  <div className="duplicateEventError">
                    Groups cannot register for the same event twice.
                  </div>
               }
               {duplicateDateError === true &&
                  <div className="duplicateDateError">
                    Individuals cannot register for two events on the same date.
                  </div>
               } */}
            </div>
         </div>
   )
}
export default EventCard;